import { IsNotEmpty, IsArray, IsString, MinLength, MaxLength, IsISO8601, IsOptional, IsInt } from 'class-validator';

export class CalendarEventDateRangeDTO {

    @IsNotEmpty()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    calendars: Array<string>;

    @IsNotEmpty()
    @IsISO8601()
    from: string;

    @IsNotEmpty()
    @IsISO8601()
    to: string;

    @IsOptional()
    @IsArray()
    @IsInt({
        each: true
    })
    types?: Array<number>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    exclude?: Array<string>;

}
